<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields['title']" label="Name" />
        </div>
        <div class="mb-4">
          <label class="label-input">Title</label>
          <ckeditor :editor="editor" v-model="fields.featuredOfferTitle" :config="editorConfig" />
        </div>
        <v-row>
          <v-col md="6" cols="12">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="backgroundColor"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['colors'].backgroundColor"
                @change="handleChangeBackgroundColor"
              />
              <v-text-field v-model="fields['colors'].backgroundColor" label="Background Color" />
              <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
            </div>
          </v-col>
          <v-col md="6" cols="12">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="backgroundColorContent"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['colors'].backgroundColorContent"
                @change="handleChangeBackgroundColorContent"
              />
              <v-text-field v-model="fields['colors'].backgroundColorContent" label="Background Content Color" />
              <v-btn @click="handleResetBackgroundColorContent" small text color="primary"> Reset </v-btn>
            </div>
          </v-col>
          <v-col md="6" cols="12">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="backgroundColorCard"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['colors'].backgroundColorCard"
                @change="handleChangeBackgroundColorCard"
              />
              <v-text-field v-model="fields['colors'].backgroundColorCard" label="Background Card Color" />
              <v-btn @click="handleResetBackgroundColorCard" small text color="primary"> Reset </v-btn>
            </div>
          </v-col>
          <v-col md="6" cols="12">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="borderColor"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['colors'].borderColor"
                @change="handleChangeBorderColor"
              />
              <v-text-field v-model="fields['colors'].borderColor" label="Border Color" />
              <v-btn @click="handleResetBorderColor" small text color="primary"> Reset </v-btn>
            </div>
          </v-col>
        </v-row>
        <div class="mt-4">
          <label class="label-input mb-4 d-flex align-center gap-2" htmlFor="imageShow" style="width: fit-content">
            <span>Image</span>
            <input class="ml-2 cursor-pointer" type="checkbox" v-model="fields['imageShow']" id="imageShow" />
          </label>
          <v-select
            v-if="fields['imageShow']"
            :value="fields['imagePosition']"
            :items="imagePostionOptions"
            label="Image Position"
            @change="handleChangeImagePosition"
          />
          <UploadImage
            v-if="fields['imageShow']"
            @callback="handleUploadImage"
            :image="{ imageSrc: fields['image'] }"
            :height="`250`"
            :typeUpload="'image'"
            @callbackDelete="handleRemoveImage"
          />
        </div>
        <div class="mt-6">
          <label class="label-input">Content Header</label>
          <ckeditor :editor="editor" v-model="fields.contentHeader" :config="editorConfig" />
        </div>
        <div class="mt-6">
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label class="label-input mb-0">Button</label>
            <input type="checkbox" v-model="fields['buttonShow']" id="showBtn" />
          </div>
          <v-row v-if="fields['buttonShow'] === true">
            <v-col md="6" cols="12">
              <v-select
                :value="fields['buttonPosition']"
                :items="buttonPositionOptions"
                label="Button Position"
                @change="handleChangeButtonPosition"
              />
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field v-model="fields['buttonText']" label="Button Text" />
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="buttonBackgroundColor"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['colors'].buttonBackgroundColor"
                  @change="handleChangeButtonBackgroundColor"
                />
                <v-text-field v-model="fields['colors'].buttonBackgroundColor" label="Button Background Color" />
                <v-btn @click="handleResetButtonBackgroundColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="buttonTextColor"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['colors'].buttonTextColor"
                  @change="handleChangeButtonTextColor"
                />
                <v-text-field v-model="fields['colors'].buttonTextColor" label="Button Text Color" />
                <v-btn @click="handleResetButtonTextColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center gap-3 mb-4 cursor-pointer">
                <label class="mr-2" for="buttonAnimation">Button Animation</label>
                <input type="checkbox" v-model="fields['buttonAnimation']" id="buttonAnimation" />
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mt-6">
          <label class="label-input">Content Footer</label>
          <ckeditor :editor="editor" v-model="fields.contentFooter" :config="editorConfig" />
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update';
export default {
  name: 'featured-offer-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      imagePostionOptions: [
        {
          text: 'Left',
          value: 'left',
        },
        {
          text: 'Right',
          value: 'right',
        },
      ],
      buttonPositionOptions: [
        {
          text: 'Center',
          value: 'center',
        },
        {
          text: 'Left',
          value: 'left',
        },
        {
          text: 'Right',
          value: 'right',
        },
      ],
      fields: {
        title: '',
        featuredOfferTitle: '',
        buttonShow: true,
        buttonText: 'GET 50% OFF →',
        buttonPosition: 'center',
        buttonAnimation: true,
        imagePosition: 'left',
        image: '',
        imageShow: true,
        contentHeader: '',
        contentFooter: '',
        topPadding: true,
        bottomPadding: true,
        colors: {
          backgroundColor: '#ffffff',
          borderColor: '#707071',
          backgroundColorContent: '#FEFDEA',
          backgroundColorCard: '#ffffff',
          buttonBackgroundColor: '#90CF5B',
          buttonTextColor: '#ffffff',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleUploadImage(obj) {
      this.fields['image'] = obj.imageSrc;
    },
    handleRemoveImage() {
      this.fields['image'] = '';
    },
    handleChangeBackgroundColor(event) {
      this.fields['colors'].backgroundColor = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['colors'].backgroundColor = '#ffffff';
    },
    handleChangeBorderColor(event) {
      this.fields['colors'].borderColor = event.target.value;
    },
    handleResetBorderColor() {
      this.fields['colors'].borderColor = '#707071';
    },
    handleChangeBackgroundColorContent(event) {
      this.fields['colors'].backgroundColorContent = event.target.value;
    },
    handleResetBackgroundColorContent() {
      this.fields['colors'].backgroundColorContent = '#FEFDEA';
    },
    handleChangeBackgroundColorCard(event) {
      this.fields['colors'].backgroundColorCard = event.target.value;
    },
    handleResetBackgroundColorCard() {
      this.fields['colors'].backgroundColorCard = '#ffffff';
    },
    handleChangeButtonBackgroundColor(event) {
      this.fields['colors'].buttonBackgroundColor = event.target.value;
    },
    handleResetButtonBackgroundColor() {
      this.fields['colors'].buttonBackgroundColor = '#90CF5B';
    },
    handleChangeButtonTextColor(event) {
      this.fields['colors'].buttonTextColor = event.target.value;
    },
    handleResetButtonTextColor() {
      this.fields['colors'].buttonTextColor = '#ffffff';
    },
    handleChangeImagePosition(value) {
      this.fields['imagePosition'] = value;
    },
    handleChangeButtonPosition(value) {
      this.fields['buttonPosition'] = value;
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFeaturedOffer(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ck-editor__editable {
  min-height: 150px !important;
}
::v-deep .ck-editor__editable_inline {
  min-height: 150px !important;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.post-content-text {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  font-weight: 500;
}
.comment-content-text {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
</style>
